<template>
  <donut-tabs
    class="m-tx4"
    :tabs="tabs"
    :initial-tab="initialTab"
    :can-select-tabs="false"
  />
</template>

<script setup>
const props = defineProps({
  initialTabValue: { type: String, required: true },
});

const tabs = [
  { title: 'Basics', value: 'show', link: '/shoutouts/settings' },
  { title: 'Values', value: 'tags', link: '/shoutouts/tags' },
];

const initialTab = tabs.find((tab) => tab.value === props.initialTabValue);
</script>
